import React from "react";
import {
  Badge,
  Button,
  Card,
  CardHeader,
  CardTitle,
  Col,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Input,
  Row,
  UncontrolledDropdown,
} from "reactstrap";
// ** Icons Imports
import { Fragment, useState } from "react";
import DataTable from "react-data-table-component";
import {
  ChevronDown,
  Copy,
  File,
  FileText,
  Grid,
  Printer,
  Share,
} from "react-feather";
import { useDispatch, useSelector } from "react-redux";

import { useEffect } from "react";
import ReactPaginate from "react-paginate";

import moment from "moment/moment";
import { PlusCircleDotted } from "react-bootstrap-icons";
import { toast } from "react-hot-toast";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import HandleDispatch from "../../common/utils/HandledDispatch";
import { getAllUtilities, getData } from "../../redux/utilities";
import { deleteUtilityType } from "../../redux/utilityTypes";
import { formatCurrency } from "../../utility/Utils";
import Loading from "../loading";
import NewUtilityType from "../utilityTypes/typeForm";
import UtilityForm from "./form";

const MySwal = withReactContent(Swal);

export default function UtilityList() {
  const [showmodal, setModalShow] = useState(false);
  const dispatch = useDispatch();
  const [selectedRow, setSelectedRow] = useState();

  const [utypeModal, setUtypeModal] = useState(false);

  const store = useSelector((state) => state.utilities);

  const handleConfirmDelete = (id) => {
    return MySwal.fire({
      title: `Delete Utility Type?`,
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      customClass: {
        confirmButton: "btn btn-primary",
        cancelButton: "btn btn-danger ms-1",
      },
      buttonsStyling: false,
    }).then(async (result) => {
      if (result.value) {
        const responseStatus = await HandleDispatch(
          dispatch,
          deleteUtilityType(id)
        );
        if (responseStatus) {
          toast.success("Utility Type has been Deleted.");
        }
      }
    });
  };
  const columns = [
    {
      name: "Type",
      sortable: true,
      sortField: "type",
      selector: (row) => row.type?.type ?? "",
      cell: (row) => (
        <div className="">
          <span className="fw-bolder">{row.type?.type ?? ""}</span>
        </div>
      ),
    },
    {
      name: "Agreement",

      selector: (row) => row.agreement,
      cell: (row) => (
        <div className="">
          <span className="fw-bolder">
            {row.agreement?.agreementName ?? ""}
          </span>
        </div>
      ),
    },

    {
      name: "Description",

      // selector: (row) => row.unit ?? "",
      cell: (row) => (
        <div className="">
          {row.type?.unit && (
            <p className="mb-0">
              Last: {row.prev}
              {row.type.unit} <br />
              New : {row.current}
              {row.type.unit}
            </p>
          )}
        </div>
      ),
    },
    {
      name: "Amount",
      sortable: true,
      sortField: "rate",
      selector: (row) => row.amount ?? "",
      cell: (row) => (
        <div className="">
          <span className="fw-bolder">{formatCurrency(row.amount) ?? ""}</span>
        </div>
      ),
    },
    {
      name: "reference",
      selector: (row) => row.referance ?? "",
      cell: (row) => (
        <div className="">
          <span className="fw-bolder">{row.referance}</span>
        </div>
      ),
    },

    {
      name: "Status",
      minWidth: "100px",
      sortable: true,
      sortField: "status",
      selector: (row) => row.status,
      cell: (row) => (
        <Badge
          color={row.status ? "success" : "danger"}
          className="text-capitalize"
        >
          <span className="">{row.status ? "Active" : "InActive"}</span>
        </Badge>
      ),
    },
    {
      name: "Due Date",
      minWidth: "100px",
      sortable: true,
      sortField: "date",
      selector: (row) => row.date,
      cell: (row) => (
        <span className="text-capitalize">
          {" "}
          {moment(row.date).format("DD-MMM-YYYY")}
        </span>
      ),
    },
    {
      name: "User",
      minWidth: "100px",
      sortable: true,
      sortField: "user",
      selector: (row) => row.createdBy,
      cell: (row) => <span className="">{row.createdBy?.username}</span>,
    },
  ];

  const [currentPage, setCurrentPage] = useState(1);

  const [rowsPerPage, setRowsPerPage] = useState(10);

  const CustomPagination = () => {
    const count = Number(Math.ceil(store.total / rowsPerPage));

    return (
      <ReactPaginate
        previousLabel={""}
        nextLabel={""}
        pageCount={count || 1}
        activeClassName="active"
        forcePage={currentPage !== 0 ? currentPage - 1 : 0}
        onPageChange={(page) => handlePagination(page)}
        pageClassName={"page-item"}
        nextLinkClassName={"page-link"}
        nextClassName={"page-item next"}
        previousClassName={"page-item prev"}
        previousLinkClassName={"page-link"}
        pageLinkClassName={"page-link"}
        containerClassName={
          "pagination react-paginate justify-content-end my-2 pe-1"
        }
      />
    );
  };

  const handlePagination = (page) => {
    const params = {
      page: page.selected + 1,
      limit: rowsPerPage,
    };

    dispatch(getData(params));
    setCurrentPage(page.selected + 1);
  };

  const dataToRender = () => {
    return store.data;
  };
  const CustomHeader = ({
    store,
    toggleSidebar,
    handlePerPage,
    rowsPerPage,
    handleFilter,
    searchTerm,
  }) => {
    // ** Converts table to CSV
    function convertArrayOfObjectsToCSV(array) {
      let result;

      const columnDelimiter = ",";
      const lineDelimiter = "\n";
      const keys = Object.keys(store.data[0]);

      result = "";
      result += keys.join(columnDelimiter);
      result += lineDelimiter;

      array.forEach((item) => {
        let ctr = 0;
        keys.forEach((key) => {
          if (ctr > 0) result += columnDelimiter;

          result += item[key];

          ctr++;
        });
        result += lineDelimiter;
      });

      return result;
    }
    // ** Downloads CSV
    function downloadCSV(array) {
      const link = document.createElement("a");
      let csv = convertArrayOfObjectsToCSV(array);
      if (csv === null) return;

      const filename = "export.csv";

      if (!csv.match(/^data:text\/csv/i)) {
        csv = `data:text/csv;charset=utf-8,${csv}`;
      }

      link.setAttribute("href", encodeURI(csv));
      link.setAttribute("download", filename);
      link.click();
    }

    return (
      <div className="invoice-list-table-header w-100 me-1 ms-50 mt-2 mb-75">
        <Row>
          <Col xl="6" className="d-flex align-items-center p-0">
            <div className="d-flex align-items-center w-100">
              <label htmlFor="rows-per-page">Show</label>
              <Input
                className="mx-50"
                type="select"
                id="rows-per-page"
                value={rowsPerPage}
                onChange={handlePerPage}
                style={{ width: "5rem" }}
              >
                <option value="10">10</option>
                <option value="25">25</option>
                <option value="50">50</option>
                <option value="50">100</option>
              </Input>
              <label htmlFor="rows-per-page">Entries</label>
            </div>
          </Col>
          <Col
            xl="6"
            className="d-flex align-items-sm-center justify-content-xl-end justify-content-start flex-xl-nowrap flex-wrap flex-sm-row flex-column pe-xl-1 p-0 mt-xl-0 mt-1"
          >
            <div className="d-flex align-items-center mb-sm-0 mb-1 me-1">
              <label className="mb-0" htmlFor="search-invoice">
                Search:
              </label>
              <Input
                id="search-invoice"
                className="ms-50 w-100"
                type="text"
                value={searchTerm}
                // onChange={(e) => handleFilter(e.target.value)}
              />
            </div>

            <div className="d-flex align-items-center table-header-actions">
              <UncontrolledDropdown className="me-1">
                <DropdownToggle color="secondary" caret outline>
                  <Share className="font-small-4 me-50" />
                  <span className="align-middle">Export</span>
                </DropdownToggle>
                <DropdownMenu>
                  <DropdownItem className="w-100">
                    <Printer className="font-small-4 me-50" />
                    <span className="align-middle">Print</span>
                  </DropdownItem>
                  <DropdownItem
                    className="w-100"
                    onClick={() => downloadCSV(store.data)}
                  >
                    <FileText className="font-small-4 me-50" />
                    <span className="align-middle">CSV</span>
                  </DropdownItem>
                  <DropdownItem className="w-100">
                    <Grid className="font-small-4 me-50" />
                    <span className="align-middle">Excel</span>
                  </DropdownItem>
                  <DropdownItem className="w-100">
                    <File className="font-small-4 me-50" />
                    <span className="align-middle">PDF</span>
                  </DropdownItem>
                  <DropdownItem className="w-100">
                    <Copy className="font-small-4 me-50" />
                    <span className="align-middle">Copy</span>
                  </DropdownItem>
                </DropdownMenu>
              </UncontrolledDropdown>
            </div>
          </Col>
        </Row>
      </div>
    );
  };

  const ToggleModal = () => {
    setModalShow(false);
    setSelectedRow(null);
  };
  const ToggleTypeModal = () => {
    setUtypeModal(false);
  };

  const handlePerPage = (e) => {
    const value = parseInt(e.currentTarget.value);
    dispatch(
      getData({
        limit: value,
        page: currentPage,
      })
    );
    setRowsPerPage(value);
  };

  useEffect(() => {
    dispatch(getAllUtilities());
  }, []);

  return (
    <Fragment>
      <Card className="overflow-hidden">
        <CardHeader className="d-flex align-items-start">
          <CardTitle tag="h4">Utility Management</CardTitle>
          <NewUtilityType
            show={utypeModal}
            ShowModal={ToggleTypeModal}
            row={selectedRow}
          />
          <UtilityForm
            show={showmodal}
            ShowModal={ToggleModal}
            toggleType={() => setUtypeModal(true)}
            row={selectedRow}
          />
          <Button
            className=""
            color="primary"
            onClick={() => setModalShow(true)}
          >
            <PlusCircleDotted className="me-1" size={20} /> New Utility
          </Button>
        </CardHeader>
        <div className="react-dataTable">
          {store.loading ? (
            <Loading cols={columns} />
          ) : (
            <DataTable
              noHeader
              subHeader
              sortServer
              pagination
              responsive
              paginationServer
              columns={columns}
              // onSort={handleSort}
              sortIcon={<ChevronDown />}
              className="react-dataTable"
              paginationComponent={CustomPagination}
              data={dataToRender()}
              subHeaderComponent={
                <CustomHeader
                  store={store}
                  // searchTerm={searchTerm}
                  rowsPerPage={rowsPerPage}
                  // handleFilter={handleFilter}
                  handlePerPage={handlePerPage}
                  // toggleSidebar={toggleSidebar}
                />
              }
            />
          )}
        </div>
      </Card>
    </Fragment>
  );
}
